import { Button } from "@volt_developers/react-ui-components";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useOperationState } from "../../../../hooks/operationsState";
import { operationPath } from "../../store";
import CodeInput from "./CodeInputField";

import type { TwoFAConfirmationCode } from "../../models/TwoFAConfirmationCode";

export interface TwoFAEnableFormProps {
  onSubmit: (values: TwoFAConfirmationCode) => void;
}

export function TwoFAEnableForm({ onSubmit }: TwoFAEnableFormProps) {
  const { t } = useTranslation();
  const {
    operationLoading,
    operationError,
  } = useOperationState(operationPath.enableTwoFA, { defaultLoading: false });

  const {
    handleSubmit,
    formState: { errors },
    control,
    setError,
  } = useForm<TwoFAConfirmationCode>({
    defaultValues: {
      code: "",
    },
  });

  useEffect(() => {
    if (operationError?.exception) {
      setError("code", {
        type: "api",
        message: operationError.exception.message,
      });
    }
  }, [operationError, setError]);

  return (
    <StyledForm
      data-testid="user-settings-twofa-dialog-form"
      onSubmit={handleSubmit(onSubmit)}
    >
      <CodeInput
        control={control}
        errors={errors}
        data-testid="user-settings-twofa-dialog-form-input"
      />
      <Button
        color="success"
        type="submit"
        variant="solid"
        size="large"
        isLoading={operationLoading}
        data-testid="user-settings-twofa-dialog-form-enable"
        fullWidth
      >
        {t("Enable")}
      </Button>
    </StyledForm>
  );
}

const StyledForm = styled.form`
  width: 232px;
  display: flex;
  flex-direction: column;
  margin: 0 auto 32px;
`;
